import React from 'react';
import Container from '../layout/Container';
import Eyebrow from '../ui/Eyebrow';
import { colors, font } from '../../lib/tokens';

// A short, high-impact mission statement. Echoes the hero's typographic device
// — a word set in italic + muted colour — to stay typographically cohesive, and
// reuses the faint peak silhouette motif from the hero / CTA.
export default function StrategySection() {
  return (
    <section
      id="strategy"
      className="kc-section"
      style={{
        background: colors.bg,
        borderTop: `1px solid ${colors.hair}`,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Faint peak silhouette, top-left — mirrors the hero/CTA motif. Traces
          itself in when the section arrives and drifts against the scroll. */}
      <svg
        data-draw
        className="kc-draw kc-drift"
        width={560}
        height={460}
        viewBox="0 0 560 460"
        aria-hidden
        style={{
          position: 'absolute',
          left: -60,
          top: -20,
          opacity: 0.05,
          pointerEvents: 'none',
          '--kc-draw-dur': '2200ms',
          '--kc-draw-d': '150ms',
        } as React.CSSProperties}
      >
        <path d="M40 420L280 70l240 350H40z" pathLength={1} fill="none" stroke={colors.ink} strokeWidth={1.4} />
        <path d="M150 420L280 230l130 190" pathLength={1} fill="none" stroke={colors.ink} strokeWidth={1} />
      </svg>

      <Container>
        <div data-reveal style={{ position: 'relative', zIndex: 1, maxWidth: 880 }}>
          <Eyebrow>Our strategy</Eyebrow>
          <h2
            className="text-balance"
            style={{
              fontFamily: font.sans,
              fontSize: 'clamp(30px, 4.6vw, 52px)',
              lineHeight: 1.08,
              letterSpacing: '-0.034em',
              fontWeight: 500,
              color: colors.ink,
              margin: '24px 0 0',
            }}
          >
            Use artificial intelligence{' '}
            <span className="kc-em">responsibly</span>{' '}
            to automate the most{' '}
            <span className="kc-em">burdensome</span>{' '}
            processes inside the healthcare system.
          </h2>
        </div>
      </Container>
    </section>
  );
}
